import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'flightMinMaxFilter'
})
export class FlightMinMaxFilterPipe implements PipeTransform {

  transform(flights: any[], type: 'min' | 'max'): Date | null {
    if (!flights?.length) return null;
    const allDates = flights
      .flatMap(f => f.segments?.flatMap(s => s.routes ?? []) ?? [])
      .flatMap(r => [r.dep_time, r.arr_time])
      .map(this.parseDateTime)
      .filter((d): d is Date => !!d);
    if (!allDates.length) return null;

    const getTime = (d: Date) => d.getTime();
    const min = new Date(Math.min(...allDates.map(getTime)));
    const max = new Date(Math.max(...allDates.map(getTime)));
    return type === 'min' ? min : max;
  }

  private parseDateTime = (dateStr: string): Date | null => {
    if (!dateStr) return null;
    const [d, t] = dateStr.split(' ');
    if (!d || !t) return null;
    const [y, m, day] = d.split('-').map(Number);
    const [h, min, s] = t.split(':').map(Number);
    return new Date(y, m - 1, day, h, min, s);
  };
}